import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { Banner } from 'src/app/home/models/home.model';

export enum ImageTag {
  mobile = 'Mobile',
  desktop = 'Desktop',
  layoutCard = 'LayoutCard'
}
@Component({
  standalone: true,
  selector: 'base-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule]
})
export class BannerComponent {

  readonly banner = input<Banner | null>(null);


  constructor(
  ) { }

  get desktopUrl() {
    const bannerData = this.banner();
    if (!bannerData?.images?.length) {
      return null;
    }
    return bannerData.images.find(image => image?.tag === ImageTag.desktop)?.url || '';
  }

  get mobileUrl() {
    const bannerData = this.banner();
    if (!bannerData?.images?.length) {
      return null;
    }
    return bannerData?.images?.find(image => image?.tag === ImageTag.mobile)?.url || '';
  }

  get layoutMobileUrl() {
    const bannerData = this.banner();
    if (!bannerData?.images?.length) {
      return null;
    }
    return bannerData.images.find(image => image?.tag === ImageTag.layoutCard)?.url || '';
  }


}

